export default "__VITE_ASSET__CtNsOaqp__"